module.exports = __webpack_public_path__ + "img/video-connectivy-2.d73e109c.png";